import { render, staticRenderFns } from "./supervisionManagmentLists.vue?vue&type=template&id=40095171&scoped=true"
import script from "./supervisionManagmentLists.vue?vue&type=script&lang=js"
export * from "./supervisionManagmentLists.vue?vue&type=script&lang=js"
import style0 from "./supervisionManagmentLists.vue?vue&type=style&index=0&id=40095171&prod&lang=scss&scoped=true"
import style1 from "./supervisionManagmentLists.vue?vue&type=style&index=1&id=40095171&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40095171",
  null
  
)

export default component.exports